import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rastreador-entrada-list',
  templateUrl: './rastreador-entrada-list.component.html',
  styleUrls: ['./rastreador-entrada-list.component.scss']
})
export class RastreadorEntradaListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
